import { CaseTypeDocumentTemplateModel } from '../caseTypeDocumentTemplate/caseTypeDocumentTemplateModel';
import { DocumentTemplateModel } from './documentTemplateModel';

export class EditDocumentTemplateModel extends DocumentTemplateModel{
    caseTypeDocumentTemplates: CaseTypeDocumentTemplateModel[];
    isFileRemoved: boolean;
    public templateFile: File;
}
